import React, { useContext } from "react";
import {
  Box,
  HStack,
  Text,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { UsersContext } from "../../Context/UsersContext";
import { useLocation } from "react-router-dom";
import { userIsAllowed } from "../../../Utils/userIsAllowed";

const Item = ({ title, sections, onClose, actionsIdAllowed }) => {
  const { currentUser } = useContext(UsersContext);
  const location = useLocation();
  const maxSectionRole = sections.reduce((max, section) => {
    return section.minRole > max ? section.minRole : max;
  }, 1);

  if (actionsIdAllowed && !userIsAllowed(currentUser, actionsIdAllowed)) {
    return null;
  }

  const validateRole = (section) => {
    if (
      section.actionsIdAllowed &&
      !userIsAllowed(currentUser, section.actionsIdAllowed)
    ) {
      return null;
    }

    if (
      section.minRole === undefined ||
      currentUser.roleId <= section.minRole
    ) {
      return (
        <AccordionPanel pb={2} key={section.name} onClick={onClose}>
          <Link to={section.url}>
            <HStack
              _hover={{ color: "menu.100" }}
              pl="0.5rem"
              spacing="1"
              color={location.pathname === section.url ? "white" : "inherit"}
            >
              {section.icon}
              <Text fontSize="0.9rem" pl={"0.25rem"}>
                {section.name}
              </Text>
            </HStack>
          </Link>
        </AccordionPanel>
      );
    }
    return null;
  };

  if (currentUser.roleId <= maxSectionRole) {
    return (
      <AccordionItem style={{ borderStyle: "none" }}>
        <AccordionButton name={`accordion_item_${title}`}>
          <Box flex="1" textAlign="left" color="menu.100" fontSize="0.9rem">
            {title}
          </Box>
          <AccordionIcon />
        </AccordionButton>
        {sections.map((section) => validateRole(section))}
      </AccordionItem>
    );
  }
};

export default Item;
